import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProcessSection } from '../components/ProcessSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
const META_PIXEL_ID = '1248476953463026';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel(META_PIXEL_ID);
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-gray-300 selection:bg-amber-500/30 selection:text-amber-200 overflow-hidden" data-id="element-139">
      <main data-id="element-140">
        <HeroSection data-id="element-141" />
        <ProblemSection data-id="element-142" />
        <FailedSolutions data-id="element-143" />
        <MechanismSection data-id="element-144" />
        <DeliverablesSection data-id="element-145" />
        <AudienceSection data-id="element-146" />
        <ProcessSection data-id="element-147" />
        <ProofSection data-id="element-148" />
        <FAQSection data-id="element-149" />
        <OfferSection data-id="element-150" />
      </main>
      <FooterSection data-id="element-151" />
    </div>;
}